import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col, Card, Badge, Button } from "react-bootstrap";
import BlogDataList from "./property-data.json";
import Icon from "@mdi/react";
import { mdiMapMarkerRadiusOutline, mdiStar, mdiOpenInNew } from "@mdi/js";
import { AnimatePresence, motion } from "framer-motion";
import '../../App.css';


export default function FeaturedProperties() {
  const [BlogItemList] = useState(BlogDataList);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const titleRef = useRef(null);

  useEffect(() => {
    const titleEl = titleRef.current;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-lines");
          } else {
            entry.target.classList.remove("animate-lines");
          }
        });
      },
      { threshold: 0.3 }
    );

    if (titleEl) observer.observe(titleEl);
    return () => {
      if (titleEl) observer.unobserve(titleEl);
    };
  }, []);

  return (
    <section className="section" id="blog">
      <Container>
        {/* Title */}
        <Row>
          <Col md={12}>
            <div className="section-title-box">
              <h1 className="section-title" ref={titleRef}>
                Location<span className="text-primary"> Advantages</span>
                <div className="title-line before-line" />
                <div className="title-line after-line" />
              </h1>
            </div>
          </Col>
        </Row>

        {/* Blog Grid */}
        <motion.div
          whileInView={{ scale: 1 }}
          initial={{ scale: 0.8 }}
          transition={{ type: "linear", stiffness: 100, duration: 1 }}
        >
          <Row className="hover-cards-container">
            {BlogItemList.blogItemListData3.map((data, i) => (
              <Col md={6} xxl={3} key={i} className="mt-4 mt-xxl-0">
                <div
                  className="hover-card-wrapper position-relative"
                  onMouseEnter={() => setHoveredIndex(i)}
                  onMouseLeave={() => setHoveredIndex(null)}
                >
                  <AnimatePresence>
                    {hoveredIndex === i && (
                      <motion.div
                        className="hover-overlay"
                        layoutId="hoverBackground"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1, transition: { duration: 0.25 } }}
                        exit={{ opacity: 0, transition: { duration: 0.2, delay: 0.1 } }}
                      />
                    )}
                  </AnimatePresence>

                  <a
                    href={data.blogLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-decoration-none text-white"
                  >
                    <Card className="overflow-hidden mb-0 h-100 rounded-3 position-relative">
                      <Card.Body>
                        <img
                          src={require(`../../images/property-img/${data.blogImg}`)}
                          alt=""
                          className="rounded img-fluid img-shadow blog-img"
                        />

                        <div className="blog-content">
                          <div className="d-flex justify-content-between mt-4 mb-2">
                            <h6 className="fs-17 mb-0 me-2">{data.blogTitle}</h6>
                            <div>
                              <Badge bg="soft-success"></Badge>
                            </div>
                          </div>

                          <div className="d-flex text-white opacity-85 fs-14">
                            <Icon
                              path={mdiMapMarkerRadiusOutline}
                              className="icon-size-18 me-2"
                            />
                            {data.blogLocation}
                          </div>

                          <div className="d-flex justify-content-between align-items-center mt-3">
                            <div className="d-flex text-warning">
                              <Icon path={mdiStar} className="icon-size-18 me-1" />
                              <Icon path={mdiStar} className="icon-size-18 me-1" />
                              <Icon path={mdiStar} className="icon-size-18 me-1" />
                              <Icon path={mdiStar} className="icon-size-18 me-1" />
                              <Icon path={mdiStar} className="icon-size-18" />
                            </div>
                            <h4 className="mb-0">{data.blogItemPrice}</h4>
                          </div>

                          <div className="mt-3">
                            <Button
                              variant="outline-dark"
                              size="sm"
                              href={data.blogLink}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Visit Link <Icon path={mdiOpenInNew} size={0.8} className="ms-1" />
                            </Button>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </a>
                </div>
              </Col>
            ))}
          </Row>
        </motion.div>

        {/* Centered Image Row */}
      {/* Centered Image Row */}
<Row className="justify-content-center mt-5">
  <Col md={10} className="text-center">
    <motion.img
      src={require(`../../images/property-img/${BlogItemList.centerImage[0].img}`)}
      alt={BlogItemList.centerImage[0].alt}
      className="img-fluid rounded shadow center-hover-image"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      whileHover={{ scale: 1.05 }}
      style={{
        height: "87%", // ← Change this value as needed
        width: "85%",   // ← You can use a fixed width like "600px" or %
        objectFit: "cover",
        transition: "transform 0.3s ease",
        cursor: "pointer",
      }}
    />
  </Col>
</Row>

      </Container>
    </section>
  );
}
